import React from "react";
import * as CHQ from "chq";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type StoryCreatedNotificationProps = {
  notification?: CHQ.NotificationStoryShared;
  tabIndex?: number;
};

const StorySharedNotification: React.FC<StoryCreatedNotificationProps> = () => (
  <NotificationBody badge="book">
    <Trans>Your story prompt was sent successfully!</Trans>
  </NotificationBody>
);

export default StorySharedNotification;
